module.exports = __webpack_public_path__ + "static/media/Avatars_Male-25.0b667517.png";